import { useEffect, useState } from 'react';
import { ParkingFilters } from '../../../domain/parking';
import { getParkingFiltersFromLocalStorage } from '../utils';

export const useParkingFilters = () => {
  const [parkingFilters, setParkingFilters] = useState<ParkingFilters | null>(null);
  const [status, setStatus] = useState<'idle' | 'loading' | 'done'>('idle');

  const isIdle = status === 'idle';
  const isLoading = status === 'loading';
  const isDone = status === 'done';

  const getParkingFilters = async () => {
    setStatus('loading');
    const config = getParkingFiltersFromLocalStorage();
    setParkingFilters(config);
    setStatus('done');
  };

  useEffect(() => {
    getParkingFilters();
  }, []);

  return { parkingFilters, isIdle, isLoading, isDone };
};
